/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	ExportTargetMappingDeletePathParams,
	ExportTargetMappingDeleteResponse,
} from '../types/ExportTargetMappingDelete'

/**
 * DELETE /export-target-mappings/:mapping
 * @see backend/nexus/modules/ExportIntegrations/Http/Controllers/ExportTargetMappingController.php ExportTargetMappingController::delete
 */
export async function exportTargetMappingDelete(
	mapping: ExportTargetMappingDeletePathParams['mapping'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ExportTargetMappingDeleteResponse>> {
	return axiosInstance.delete(`/export-target-mappings/${mapping}`, config)
}
